import React from 'react';
import { TableController } from './TableController';
import { TableComponent } from './TableComponent';

export { TableSkeleton } from './TableSkeleton';

export const HGTable = (props) => {
    return (
        <>
            <TableController {...props} />
            <TableComponent {...props} />
        </>
    );
};
